import { BreadcrumbItemCombinedProps } from './types';

const usePresenter = (props: BreadcrumbItemCombinedProps): BreadcrumbItemCombinedProps => {
  return props;
};

export default usePresenter;
